/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { HierarchiesControllerGetStatisticsQueryResponse, HierarchiesControllerGetStatisticsPathParams, HierarchiesControllerGetStatisticsQueryParams, HierarchiesControllerGetStatistics400, HierarchiesControllerGetStatistics401, HierarchiesControllerGetStatistics403, HierarchiesControllerGetStatistics404 } from "../../models/hierarchiesController/HierarchiesControllerGetStatistics";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { hierarchiesControllerGetStatistics } from "../../clients/hierarchiesService/hierarchiesControllerGetStatistics";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const hierarchiesControllerGetStatisticsQueryKey = (scopeId: HierarchiesControllerGetStatisticsPathParams["scopeId"], params: HierarchiesControllerGetStatisticsQueryParams) => [{
  url: '/api/v1/hierarchies/:scopeId/stats',
  params: {
    scopeId: scopeId
  }
}, ...(params ? [params] : [])] as const;
export type HierarchiesControllerGetStatisticsQueryKey = ReturnType<typeof hierarchiesControllerGetStatisticsQueryKey>;
export function hierarchiesControllerGetStatisticsQueryOptions(scopeId: HierarchiesControllerGetStatisticsPathParams["scopeId"], params: HierarchiesControllerGetStatisticsQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = hierarchiesControllerGetStatisticsQueryKey(scopeId, params);
  return queryOptions<HierarchiesControllerGetStatisticsQueryResponse, ResponseErrorConfig<HierarchiesControllerGetStatistics400 | HierarchiesControllerGetStatistics401 | HierarchiesControllerGetStatistics403 | HierarchiesControllerGetStatistics404>, HierarchiesControllerGetStatisticsQueryResponse, typeof queryKey>({
    enabled: !!(scopeId && params),
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return hierarchiesControllerGetStatistics(scopeId, params, config);
    }
  });
}

/**
 * @description Get statistical information about the scope including member counts and child entity counts
 * @summary Get scope statistics
 * {@link /api/v1/hierarchies/:scopeId/stats}
 */
export function useHierarchiesControllerGetStatistics<TData = HierarchiesControllerGetStatisticsQueryResponse, TQueryData = HierarchiesControllerGetStatisticsQueryResponse, TQueryKey extends QueryKey = HierarchiesControllerGetStatisticsQueryKey>(scopeId: HierarchiesControllerGetStatisticsPathParams["scopeId"], params: HierarchiesControllerGetStatisticsQueryParams, options: {
  query?: Partial<QueryObserverOptions<HierarchiesControllerGetStatisticsQueryResponse, ResponseErrorConfig<HierarchiesControllerGetStatistics400 | HierarchiesControllerGetStatistics401 | HierarchiesControllerGetStatistics403 | HierarchiesControllerGetStatistics404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? hierarchiesControllerGetStatisticsQueryKey(scopeId, params);
  const query = useQuery({
    ...hierarchiesControllerGetStatisticsQueryOptions(scopeId, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<HierarchiesControllerGetStatistics400 | HierarchiesControllerGetStatistics401 | HierarchiesControllerGetStatistics403 | HierarchiesControllerGetStatistics404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}